<script setup lang="ts">
import { PropType } from "vue";
import { useApiClient } from "@/api/client";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import PermissableManager from "@/ui/components/permissions/PermissableManagerTree.vue";
import { useRoute } from "vue-router";

const props = defineProps({
	role: {
		type: Object as PropType<App.Data.RoleDO>,
		require: true,
	},
});

// Emit is not used in this component but required through the tabs-router-view setup.
const emit = defineEmits(["update-role"]);

const updateRolePermission = () => {
	const uuid: string | string[] = useRoute().params.uuid ?? "";
	return async (updatePermissionDTO: App.Data.UpdatePermissionDTO) => {
		return useApiClient("roles").updatePermission(updatePermissionDTO, uuid);
	};
};

const bulkUpdateRolePermission = () => {
	const uuid: string | string[] = useRoute().params.uuid ?? "";
	return async (dto: App.Data.BulkUpdatePermissionDTO) => {
		return useApiClient("roles").bulkUpdatePermission(dto, uuid);
	};
};
</script>

<template>
	<module-loading>
		<v-card class="mt-5 pa-3">
			<permissable-manager
				:async-update-function="updateRolePermission()"
				:async-bulk-update-function="bulkUpdateRolePermission()"
				:derived-permissions="role.derivedPermissions"
				:available-permissions="role.availablePermissions"
				:permission-lock-guard="role.lockoutGuardState"
			/>
		</v-card>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
